import NextScheduleAppointment from '@commons/cards/nextScheduleAppointment'
import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Circle from '@components/circle'
import Typography from '@components/typography'
import { Appointment } from '@apis'
import { useEffect, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { StyleGridItems } from './style'
import AppointmentSchedule from '@commons/cards/appointmentSchedule'
import AppointmentScheduleCardLoader from '@commons/cards/appointmentSchedule/loader'
import Empty from '@commons/empty'

const ActiveAppointments = () => {
  const {
    items: appointments,
    loading,
    totalItems,
  } = useSelector((state: any) => state.todayConsultAppointments)

  const fetchData = async () => {
    await Appointment.list({
      params: {
        page: 1,
        limit: 12,
        isToday: true,
        status: 'Confirmed',
        type: 'Consult',
        isSchedule: true,
      },
      state: 'todayConsultAppointments',
      action: 'set',
    }).catch(() => {})
  }
  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])
  return (
    <>
      <Column rowGap={20}>
        <NextScheduleAppointment />
        <CardHeading
          title={`Todays Appointments`}
          titleRightComponent={
            <Circle bg="secondary" size={20}>
              <Typography content={totalItems} size={12} tc="white" />
            </Circle>
          }
        />
        <Column bg="primary300" styleColumn="border-radius:12px;padding:20px;">
          {!!loading ? (
            <StyleGridItems>
              {Array(6)
                .fill(0)
                ?.map((_: any, index: any) => {
                  return (
                    <Fragment key={index}>
                      <AppointmentScheduleCardLoader />
                    </Fragment>
                  )
                })}
            </StyleGridItems>
          ) : (
            <>
              {!!appointments?.length ? (
                <StyleGridItems>
                  {appointments?.map((appointment: any) => {
                    return (
                      <Fragment key={appointment?.id}>
                        <AppointmentSchedule
                          appointment={appointment}
                          hasView
                        />
                      </Fragment>
                    )
                  })}
                </StyleGridItems>
              ) : (
                <Empty />
              )}
            </>
          )}
        </Column>
      </Column>
    </>
  )
}

export default ActiveAppointments
